export const STAGES = ["lead", "profilazione", "consulenza", "preventivo", "contratto"];

export const STAGE_LABELS = {
  lead: "Lead",
  primo_contatto: "Primo Contatto",
  profilazione: "Profilazione",
  consulenza: "Consulenza Tecnica",
  preventivo: "Preventivo",
  contratto: "Contratto",
};

export const SOURCE_LABELS = {
  web: "Sito web (self-service)",
  pubblicita: "Pubblicità",
  partner: "Rete Partner",
  partner_commerciale: "Partner Commerciale",
  networking: "Networking",
  prospect: "Attività promozionale / Prospect",
  ricontatto: "Richiesta di ricontatto",
  free_tool: "Strumento Free",
  free_colonnina: "Configuratore Colonnina",
};

export const PROSPECT_ACTIVITY_LABELS = {
  telefonata: "Telefonata",
  visita: "Visita",
  email: "Email",
  meet: "Meet",
  evento: "Evento",
  networking: "Networking",
  invio_materiale: "Invio materiale",
  follow_up: "Follow-up",
  preventivo: "Preventivo",
  altro: "Altro",
  stato: "Cambio stato",
};

export const TARGET_LABELS = {
  residenziale: "Residenziale",
  commerciale: "Commerciale & Industriale",
  utility: "Utility Scale",
};

export const ROLE_LABELS = {
  admin: "Amministratore",
  qualification: "Lead Qualification",
  sales: "Technical Sales",
  partner: "Partner Development",
  partner: "Head of Partner",
  partner_commerciale: "Partner Commerciale",
  team_leader: "Team Leader",
};

export const PRIORITY_META = {
  alta: { label: "Alta", className: "bg-success/15 text-success border-success/30" },
  media: { label: "Media", className: "bg-warning/15 text-warning border-warning/30" },
  bassa: { label: "Bassa", className: "bg-destructive/15 text-destructive border-destructive/30" },
};

export const LEVEL_META = {
  1: { label: "Livello 1", full: "Livello 1 · Gestione Marketing", dot: "🟢", className: "bg-success/15 text-success border-success/30" },
  2: { label: "Livello 2", full: "Livello 2 · Marketing + Sales", dot: "🟡", className: "bg-warning/15 text-warning border-warning/30" },
  3: { label: "Livello 3", full: "Livello 3 · Technical Sales", dot: "🔴", className: "bg-destructive/15 text-destructive border-destructive/30" },
};

// Deve rispecchiare la logica backend compute_score.
// La complessità tecnica è il driver principale (obbligatoria per il Livello 3);
// potenziale e probabilità sono modulatori secondari pesati.
const LEVEL_WEIGHTS = { complessita: 0.5, potenziale: 0.3, probabilita: 0.2 };
const L3_COMP_MIN = 0.4, L3_WEIGHTED_MIN = 0.45, L3_COMP_STRONG = 0.6;
const L2_WEIGHTED_MIN = 0.22, L2_COMP_MIN = 0.25, L2_SECONDARY_HIGH = 0.6;

export function computeLevel(breakdown) {
  const { potenziale = 0, complessita = 0, probabilita = 0, potenziale_max = 0, complessita_max = 0, probabilita_max = 0 } = breakdown || {};
  const compFrac = complessita_max ? complessita / complessita_max : 0;
  const potFrac = potenziale_max ? potenziale / potenziale_max : 0;
  const probFrac = probabilita_max ? probabilita / probabilita_max : 0;
  const weighted = LEVEL_WEIGHTS.complessita * compFrac + LEVEL_WEIGHTS.potenziale * potFrac + LEVEL_WEIGHTS.probabilita * probFrac;
  const isL3 = compFrac >= L3_COMP_STRONG || (compFrac >= L3_COMP_MIN && weighted >= L3_WEIGHTED_MIN);
  const isL2 = weighted >= L2_WEIGHTED_MIN || compFrac >= L2_COMP_MIN || potFrac >= L2_SECONDARY_HIGH || probFrac >= L2_SECONDARY_HIGH;
  if (isL3) return 3;
  if (isL2) return 2;
  return 1;
}

export const ACTION_LABELS = {
  chiamata: "Chiamata",
  sopralluogo: "Sopralluogo",
  consulenza: "Consulenza",
  preventivo: "Preventivo",
  trattativa: "Trattativa",
  contratto: "Contratto",
  nota: "Nota",
  profilazione: "Profilazione",
  appuntamento: "Appuntamento",
  sistema: "Sistema",
};

export const ACTION_TYPE_KEYS = ["chiamata", "sopralluogo", "consulenza", "preventivo", "trattativa", "contratto", "nota"];

export const QUALITY_CHECK_LABELS = {
  motivo_contatto: "Motivo del contatto",
  persone_presenti: "Persone presenti / interlocutore",
  esigenze: "Esigenze emerse",
  decisioni: "Decisioni prese",
  obiezioni: "Obiezioni o dubbi",
  attivita_concordate: "Attività concordate",
  prossima_azione: "Prossima azione",
  data_prossima: "Data della prossima attività",
};

export const MONTHS_IT = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];

export const POSITIONING = {
  azienda: {
    title: "Posizionamento Azienda",
    text: "Torrisolare è un produttore italiano di pannelli fotovoltaici di alta gamma. Realizziamo i pannelli più sicuri e longevi del mercato.",
    keywords: ["Fabbrica", "Robustezza", "Sicurezza", "Longevità", "Made in Italy", "Tecnologie"],
  },
  divisione: {
    title: "Posizionamento Chiavi in mano",
    text: "Oggi mettiamo questo know-how direttamente al servizio del cliente finale. Accompagniamo il cliente dalla consulenza iniziale fino alla realizzazione. Siamo l'unica fabbrica di pannelli in Europa che offre questo servizio, competitivo perché direttamente dalla fabbrica.",
    keywords: ["Consulenza dedicata", "Chiavi in mano", "Filiera diretta", "Prezzo di fabbrica"],
  },
};

export const CALL_SCRIPT = [
  { title: "Apertura", text: "Buongiorno, sono della Divisione Chiavi in Mano di Torrisolare. Ha richiesto informazioni sul nostro servizio e la contatto per comprendere meglio le sue esigenze e spiegarle come lavoriamo. Ha qualche minuto da dedicarmi?" },
  { title: "Verifica conoscenza brand", text: "Conosceva già Torrisolare oppure è il nostro primo contatto? Posso chiederle dove ci ha conosciuti? (Cliente / Partner / Social / Google / Fiera / Passaparola)" },
  { title: "Posizionamento", text: "Torrisolare è un produttore italiano di pannelli fotovoltaici di alta gamma. Realizziamo i pannelli più sicuri e longevi del mercato. Parole chiave: Fabbrica, Robustezza, Sicurezza, Longevità, Made in Italy, Tecnologie." },
  { title: "Chiavi in mano", text: "Oggi mettiamo questo know-how direttamente al servizio del cliente finale. Accompagniamo il cliente dalla consulenza iniziale fino alla realizzazione. Siamo l'unica fabbrica di pannelli in Europa che offre questo servizio, competitivo perché direttamente dalla fabbrica." },
  { title: "Spiegazione processo", text: "Ora le farò alcune domande per capire la priorità e verificare la lista d'attesa con l'ufficio tecnico. Entro 24 ore effettueremo una prima valutazione, poi svilupperemo la consulenza tecnica completa e fisseremo un appuntamento con il tecnico-commerciale." },
  { title: "Chiusura", text: "La ringrazio per il tempo dedicato. Procederemo con la valutazione tecnica e sarà nostra cura ricontattarla nei tempi indicati." },
];
